import axiosInstance from "../Utils/axiosConfig";

const getProfile = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/api/GetProfile`
  );
  return response?.data;
};

const authenticateUser = async (data) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_REST_URL}/api/AuthenticateUser/v2`,
    data
  );
  return response?.data;
};

const requestDeviceVerificationOTP = async (data) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_REST_URL}/api/Request_Device_Verification_OTP`,
    data
  );
  return response?.data;
};

const getLoginVerification = async (data) => {
  // This endpoint expects form-urlencoded data, not JSON
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_REST_URL}/token/v2`,
    data,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
  return response?.data;
};

const getAdditionalFields = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/api/Customer_AddtionalFields`
  );
  return response?.data;
};

const authService = {
  getProfile,
  getAdditionalFields,
  getLoginVerification,
  authenticateUser,
  requestDeviceVerificationOTP,
};

export default authService;
